import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";

import reducers from "./reducers";
import rootSaga from "./sagas";
import redirectMiddleware from './middlewares/redirectMiddleware';
import storageMiddleware from './middlewares/storageMiddleware';
import notificationMiddleware from "./middlewares/notificationsMiddleware";
/*
import modalMiddleware from './middlewares/modalMiddleware';
*/

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
  reducers,
  applyMiddleware(
    sagaMiddleware,
    redirectMiddleware,
    storageMiddleware,
    notificationMiddleware
  )
);

sagaMiddleware.run(rootSaga);

export default store;